// extracted by mini-css-extract-plugin
module.exports = {"menuLink":"menu-link_menuLink__1_GjX","menuLinkMargin":"menu-link_menuLinkMargin__UvF9E","image":"menu-link_image__1XWxT"};